module.exports = __webpack_public_path__ + "static/media/Fondo_3000x3000.0de96d4e.png";